<div class="ru-avail-page">
  <p-toast [style]="{marginTop: '60px'}"></p-toast>

  <!-- ── Sticky Filter Bar ─────────────────────────────────────── -->
  <div class="filter-bar" [formGroup]="form1">
    <div class="d-flex flex-wrap align-items-center gap-2">

      <span class="p-float-label">
        <p-multiSelect
          autoWidth="false"
          [ngStyle]="{'minWidth':'210px','maxWidth':'340px'}"
          [scrollHeight]="'45vh'"
          [options]="shortTermRentals"
          formControlName="shortTermRentalIds"
          defaultLabel="Select Properties"
          dataKey="shortTermRentalId"
          id="shortTermRentalIds"
          optionLabel="propertyCode"
          display="chip"
          appendTo="body">
        </p-multiSelect>
        <label for="shortTermRentalIds">Properties</label>
      </span>

      <span class="p-float-label">
        <p-calendar inputId="startDate" formControlName="startDate"
          (onSelect)="onDateChange()" [style]="{'width':'150px'}"
          appendTo="body" dateFormat="yy-mm-dd">
        </p-calendar>
        <label for="startDate">Start Date</label>
      </span>

      <span class="p-float-label">
        <p-calendar inputId="endDate" formControlName="endDate"
          [style]="{'width':'150px'}" appendTo="body"
          [minDate]="minDate" [defaultDate]="minDate" dateFormat="yy-mm-dd">
        </p-calendar>
        <label for="endDate">End Date</label>
      </span>

      <button pButton class="p-button p-button-sm" (click)="formSearch()" [disabled]="loading">
        <i class="pi pi-search me-1"></i> Search
      </button>

      <!-- Global keyword search -->
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input pInputText type="text" class="p-inputtext-sm"
          (input)="dt.filterGlobal($event.target.value, 'contains')"
          placeholder="Filter results…" style="width:160px" />
        </span>

        <!-- Mismatch toggle -->
        @if (rows.length > 0) {
          <div class="d-flex align-items-center gap-1">
            <p-inputSwitch [(ngModel)]="showMismatchOnly" [ngModelOptions]="{standalone: true}"></p-inputSwitch>
            <span class="filter-label" (click)="showMismatchOnly = !showMismatchOnly">Mismatches only</span>
          </div>
        }

        <!-- Summary badges -->
        @if (rows.length > 0) {
          <div class="d-flex gap-1">
            <span class="summary-badge badge-danger">
              <i class="pi pi-times-circle"></i> {{ mismatchCount }}
            </span>
            <span class="summary-badge badge-secondary">
              {{ rows.length }} days
            </span>
          </div>
        }

      </div>
    </div>

    <!-- ── Table (fills remaining height, scrolls internally) ────── -->
    <div class="table-wrapper">
      <p-table
        #dt
        class="kbmadmintable"
        [value]="filteredRows"
        [loading]="loading"
        [scrollable]="true"
        scrollHeight="flex"
        styleClass="p-datatable-striped p-datatable-sm"
        [resizableColumns]="true"
        [globalFilterFields]="['propertyCode', 'date']">

        <!-- Header -->
        <ng-template pTemplate="header">
          <tr>
            <th pSortableColumn="propertyCode">Property <p-sortIcon field="propertyCode"></p-sortIcon></th>
            <th pSortableColumn="date">Date <p-sortIcon field="date"></p-sortIcon></th>
            <th class="col-center">Match?</th>
            <th class="col-center">WIKI</th>
            <th class="col-center">RU Table</th>
            <th class="col-center">RU API</th>
            <th>WIKI Reservation</th>
            <th>RU Reservation</th>
          </tr>
          <tr class="filter-row">
            <td>
              <p-columnFilter type="text" field="propertyCode" matchMode="contains"
              [showMenu]="false" placeholder="Property"></p-columnFilter>
            </td>
            <td>
              <p-columnFilter field="date" [showMenu]="false">
                <ng-template pTemplate="filter" let-filter="filterCallback">
                  <input pInputText type="date"
                    (input)="filter($event.target['value'], 'date', 'contains')"
                    style="width:100%; font-size:0.78rem; padding:2px 4px;">
                  </ng-template>
                </p-columnFilter>
              </td>
              <td class="col-center">
                <p-columnFilter type="boolean" field="availabilityMatch"></p-columnFilter>
              </td>
              <td></td><td></td><td></td><td></td><td></td>
            </tr>
          </ng-template>

          <!-- Body -->
          <ng-template pTemplate="body" let-row>
            <tr [style.background-color]="getMatchRowBg(row)">

              <td>{{ row.propertyCode }}</td>
              <td>{{ row.date }}</td>

              <td class="col-center" [style.background-color]="getMatchCellBg(row)">
                <i class="pi {{ row.availabilityMatch ? 'pi-check-circle' : 'pi-times-circle' }}"
                [style.color]="row.availabilityMatch ? '#198754' : '#dc3545'"></i>
              </td>

              <td class="col-center avail-cell" [style.background-color]="getAvailBg(row.wikiAvailability)">
                {{ getAvailLabel(row.wikiAvailability) }}
              </td>
              <td class="col-center avail-cell" [style.background-color]="getAvailBg(row.ruTableAvailability)">
                {{ getAvailLabel(row.ruTableAvailability) }}
              </td>
              <td class="col-center avail-cell" [style.background-color]="getAvailBg(row.ruApiResponse)">
                {{ getAvailLabel(row.ruApiResponse) }}
              </td>

              <!-- WIKI Reservation -->
              <td>
                @if (row.wikiReservation) {
                  <a class="res-link" href="https://admin.kbmhawaii.com/reservation/{{row.wikiReservation.reservationId}}" target="_blank">
                    #{{ row.wikiReservation.reservationId }}
                  </a>
                  <span class="res-dates">{{ row.wikiReservation.checkIn }} → {{ row.wikiReservation.checkOut }}</span>
                  <span class="res-badge">{{ row.wikiReservation.status }}</span>
                } @else {
                  <span class="text-muted">—</span>
                }
              </td>

              <!-- RU Reservation -->
              <td>
                @if (row.ruReservation) {
                  <a class="res-link" href="https://new.rentalsunited.com/MyBookings/Edit/{{row.ruReservation.ruReservationId}}" target="_blank">
                    #{{ row.ruReservation.ruReservationId }}
                  </a>
                  <span class="res-guest">{{ row.ruReservation.guestName }}</span>
                  <span class="res-dates">{{ row.ruReservation.checkIn }} → {{ row.ruReservation.checkOut }}</span>
                  <span class="res-badge">{{ row.ruReservation.status }}</span>
                } @else {
                  <span class="text-muted">—</span>
                }
              </td>

            </tr>
          </ng-template>


          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="8" class="empty-msg">
                <i class="pi pi-info-circle me-1"></i>
                Select properties and a date range, then click Search.
              </td>
            </tr>
          </ng-template>

        </p-table>
      </div>

    </div>
